import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_SYSADMIN_REPORT_FINANCEIRO = [
  {
    module: 'REPORT_FINANCEIRO_GERAL',
    colunas: [
      {
        field: 'name',
        active: true,
        removable: false
      },
      {
        field: 'doc',
        active: true,
        removable: true
      },
      {
        field: 'application',
        active: true,
        removable: true
      },
      {
        field: 'dia_vencimento',
        active: true,
        removable: true
      },
      {
        field: 'valor_aquisicao',
        active: true,
        removable: true
      },
      {
        field: 'valor_recorrencia',
        active: true,
        removable: true
      },
      {
        field: 'valor_papeis_extra',
        active: true,
        removable: true
      },
      {
        field: 'valor_recorrencia_total',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
